module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-manual-wrap"
  }, [_c('form', {
    staticStyle: {
      "width": "30%"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("請輸入新密碼")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass),
      expression: "newPass"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "新密碼",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass2),
      expression: "newPass2"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "password",
      "placeholder": "確認新密碼",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPass2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("更新")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46e7b10b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserManual/Password.vue
// module id = 1460
// module chunks = 1